import { render, staticRenderFns } from "./delete-disclaimer-modal.vue?vue&type=template&id=0aec46e9"
import script from "./delete-disclaimer-modal.vue?vue&type=script&lang=ts"
export * from "./delete-disclaimer-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports